<template>
    <section class="relative block xs-max:pb-8">
        <div
            class="relative z-30 flex items-center xs-max:!px-0 justify-end px-5 py-2 mx-auto bg-white xs-max:flex-wrap sm-max:px-3 max-w-screen-2xl md:px-7 lg:px-14 xl:px-20 2xl:px-12 lg:items-center">
            <div class="flex-grow block xs-max:ml-2">
                <nuxt-img class="w-32 sm:w-48" width="192" height="94":src="logoSrc" :alt="logoAlt" />
            </div>
            <a :href="phoneHref"
                class="border bnt-basic xs-max:text-14 us-max:mr-2 sm-max:px-3 md-max:text-15" :style="{ color: primaryColor, borderColor: primaryColor }">
                <span v-html="phoneText"></span>
            </a>

            <button type="button" @click="scrollTo(scrollTarget)"
                :style="{ background: primaryColor }"
                class="ml-6 text-white bnt-basic xs-max:w-full xs-max:absolute md-max:text-15 xs-max:rounded-none xs-max:top-16 xs-max:text-14 sm-max:px-3 sm-max:ml-3">
                <span v-html="buttonText"></span>
            </button>
        </div>

    </section>

</template>

<script setup>

const props = defineProps({
    logoSrc: {
        type: String,
        default: "/assets/images/black-logo.svg"
    },
    logoAlt: {
        type: String,
        default: "Lifeboost Coffee Logo"
    },
    scrollTarget: {
        type: String,
        default: "the-products"
    },
    phoneHref: {
        type: String,
        default: "tel:1-800-479-1596"
    },
    phoneText: {
        type: String,
        default: "1-800-479-1596"
    },
    buttonText: {
        type: String,
        default: "40% off"
    },
    primaryColor: {
        type: String,
        default: "#e28831" // Това е примерна стойност за lifeboost-orange-middle
    }
})

defineBuilderComponent({
    friendlyName: "Header-4",
    inputs: [
        {
            name: "primaryColor",
            type: "color",
            defaultValue: "#e28831"
        },
        {
            name: "logoSrc",
            type: "file",
            allowedFileTypes: ["jpeg", "jpg", "svg", "png"],
            defaultValue: "/assets/images/black-logo.svg"
        },
        {
            name: "logoAlt",
            type: "text",
            defaultValue: "Lifeboost Coffee Logo"
        },
        {
            name: "phoneHref",
            type: "text",
            defaultValue: "tel:1-800-479-1596"
        },
        {
            name: "scrollTarget",
            type: "text",
            defaultValue: "the-products"
        },
        {
            name: "phoneText",
            type: "text",
            defaultValue: "1-800-479-1596"
        },
        {
            name: "buttonText",
            type: "text",
            defaultValue: "40% off"
        },]
})

</script>